import { render, staticRenderFns } from "./PageLegal.vue?vue&type=template&id=ad525dea&"
import script from "./PageLegal.vue?vue&type=script&lang=js&"
export * from "./PageLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports